import React, { useState, useEffect, useContext, useRef } from 'react';
import '../../src/assets/css/style.css';
import footer from "../../src/assets/img/mainfooterbg.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getDistrictList, getBlockList, getGpList, getSansadList, getVillageList, getCertificateList, getCertificateDocumentList, getCertificateDocumentList2
  , postCertificate, getCertificateListForCitizen, getSubCasteCertificate,
} from "../CertificateService"
import defImg from "../assets/img/download.png"
import { Location } from './LocationContext';
import { useNavigate } from 'react-router-dom';
import { Link, useSearchParams } from 'react-router-dom';
// import DEFAULT from "../../public/DEFAULT.webp"
import Modal from 'react-modal';
import stateStore from "./Zustand";
import Navbar from "./Navbar";
import ColorRingCustomLoader from "./Loader"
const AddAchievement = () => {
  const { value, setValue, setValueImage } = stateStore();
  const imageRef = useRef(null)

  const location = useContext(Location)
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const handleCloseDelete = () => setShowDelete(false);
  const [showDelete, setShowDelete] = useState(false);
  const [buttonActive, setButtonActive] = useState(false);


  const [getMobileNumber, setWhatsappNumber] = useState('');
  const [isValidWhatsapp, setIsValidWhatsapp] = useState(true);
  const [getEmail, setEmail] = useState("");
  const [getEmailInput, setEmailInput] = useState("");


  const [getDistrictDataList, setDistrictDataList] = useState([]);
  const [getBlockDataList, setBlockDataList] = useState([]);
  const [getGpDataList, setGpDataList] = useState([]);
  const [getSansadDataList, setSansadDataList] = useState([]);
  const [getVillageDataList, setVillageDataList] = useState([]);
  const [getCertificateDataList, setCertificateDataList] = useState([]);
  const [getCertificateDocumentDataList, setCertificateDocumentDataList] = useState([]);
  const [getCertificateDocumentDataList2, setCertificateDocumentDataList2] = useState([]);

  const [district, setDistrict] = useState();
  const [block, setBlock] = useState();
  const [gp, setGp] = useState();
  const [sansad, setSansad] = useState("");
  const [village, setVillage] = useState("");
  const [bengVillage, setBengVillage] = useState();
  const [assesseeNo, setAssesseeNo] = useState();
  const [assesseeName, setAssesseeName] = useState();
  const [aplicantName, setAplicantEngName] = useState();
  const [bengAplicantName, setBengAplicantName] = useState();
  const [relation, setRelation] = useState();
  const [bengRelation, setBengRelation] = useState();
  const [guardianName, setGuardianName] = useState();
  const [bengGuardianName, setBengGuardianName] = useState();
  const [relationWithGuardian, setRelationWithGuardian] = useState();
  const [bengRelationWithGuardian, setBengRelationWithGuardian] = useState();
  const [address, setAddress] = useState();
  const [bengAddress, setBengAddress] = useState();
  const [postOffice, setPostOffice] = useState('');
  const [bengPostOffice, setBengPostOffice] = useState('');
  const [policeStation, setPoliceStation] = useState();
  const [bengPoliceStation, setBengPoliceStation] = useState();
  const [pin, setPin] = useState();
  const [bengPin, setBengPin] = useState();
  const [dob, setDob] = useState();
  const [bengDob, setBengDob] = useState();
  const [certificate, setCertificate] = useState();
  const [document1, setDocument1] = useState();
  const [document2, setDocument2] = useState();
  const [uniqueNo1, setUniqueNo1] = useState();
  const [uniqueNo2, setUniqueNo2] = useState();
  const [uniqueNo3, setUniqueNo3] = useState();
  const [gsMember, setGsMember] = useState();


  const [incomeSource, setIncomeSource] = useState('');
  const [annualIncome, setAnnualIncome] = useState('');
  const [distanceFromResidential, setDistanceFromResidential] = useState('');
  const [distanceLocation, setDistanceLocation] = useState('');
  const [samePersonCurrName, setSamePersonCurrName] = useState('');
  const [samePersonOldCurrName, setSamePersonOldCurrName] = useState('');

  const [getThemeDataList, setThemeDataList] = useState([]);
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("")
  const [getImageresult2, setGetImageresult2] = useState("")
  const [image2, setImage2] = useState({ preview: "", raw: "" });
  const [getImage2, setGetImage2] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [base64String, setBase64String] = useState('');
  const [imagePreview, setImagePreview] = useState(null);

  const [base64String2, setBase64String2] = useState('');
  const [imagePreview2, setImagePreview2] = useState(null);

  const [base64String3, setBase64String3] = useState('');
  const [imagePreview3, setImagePreview3] = useState(null);

  const [currentDate, setCurrentDate] = useState('');
  const [loader, setAllLoader] = useState(false);

  const [expandedMenus, setExpandedMenus] = useState(
    // Array(2).fill({ documentId: "", docUniqueNo: "", doc: "" })
  );
  const [incomeCertificate, setIncomeCertificate] = useState('');
  const [distanceCertificate, setDistanceCertificate] = useState('');
  const [samePersonCertificate, setSamePersonCertificate] = useState('');
  const [casteCertificate, setCasteCertificate] = useState('');
  const [characterCertificate, setCharacterCertificate] = useState('');
  const [residentialCertificate, setResidentialCertificate] = useState('');
  const [gender, setGender] = useState();
  const [picImage, setPicImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [caste, setCaste] = useState()
  const [SubCasteDataList, setSubCasteDataList] = useState([])
  const [religion, setReligion] = useState();
  const [subCaste, setSubCaste] = useState()
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [unmarriedCertificate, setUnmarriedCertificate] = useState('');
  const onCheckCerReq = (language) => {
    setBengAplicantName("");
    setBengGuardianName("");
    setBengRelationWithGuardian("");
    setBengAddress("");
    setBengPostOffice("");
    setBengVillage("");
    setBengPoliceStation("");
    setBengPin("");
    setBengDob("");
    setSelectedLanguage(language === selectedLanguage ? null : language);
  };


  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the first file
    if (!file) return;
    // Check file size (100KB = 102400 bytes)
    if (file.size > 102400) {
      setErrorMessage("File size must be less than 100KB");
      setPreviewImage(null);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width < 0 || img.height < 0) {
          // setErrorMessage("Image resolution must be 360x360 pixels");
          setPreviewImage(null);
        } else {
          setErrorMessage("");
          setPreviewImage(e.target.result); // Set image preview
        }
      };

      img.src = e.target.result;
    };

    reader.onerror = () => {
      setErrorMessage("Failed to read file. Please try again.");
    };

    reader.readAsDataURL(file); // Read file as data URL
  };
  const onCharacterCer = (e) => {
    setCharacterCertificate(e.target.checked == true ? 1 : 0)

    getCertificateDocumentList(e.target.checked == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(e.target.checked == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });
  }

  const onIncomeCertificate = (e) => {
    setIncomeCertificate(e.target.checked == true ? 2 : 0)

    getCertificateDocumentList(characterCertificate == true ? 1 : 0, e.target.checked == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(characterCertificate == true ? 1 : 0, e.target.checked == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });
  }

  const onDistanceCertificate = (e) => {
    setDistanceCertificate(e.target.checked == true ? 5 : 0)

    getCertificateDocumentList(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, e.target.checked == true ? 5 : 0, characterCertificate == true ? 6 : 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, e.target.checked == true ? 5 : 0, characterCertificate == true ? 6 : 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });

  }

  const onSamePersonCertificate = (e) => {
    setSamePersonCertificate(e.target.checked == true ? 4 : 0)

    getCertificateDocumentList(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, e.target.checked == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, e.target.checked == true ? 4 : 0, distanceCertificate == true ? 5 : 0, characterCertificate == true ? 6 : 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });

  }

  const onUnmarriedCertificate = (e) => {
    setUnmarriedCertificate(e.target.checked == true ? 7 : 0)
  }



  const onCasteCertificate = (e) => {
    setCasteCertificate(e.target.checked == true ? 6 : 0)

    getCertificateDocumentList(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, e.target.checked == true ? 6 : 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(characterCertificate == true ? 1 : 0, incomeCertificate == true ? 2 : 0, 3, samePersonCertificate == true ? 4 : 0, distanceCertificate == true ? 5 : 0, e.target.checked == true ? 6 : 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });

  }


  const onIncomeSource = (e) => {
    setIncomeSource(e.target.value)
  }

  const onAnnualIncome = (e) => {
    setAnnualIncome(e.target.value)
  }

  const onDisFromRes = (e) => {
    setDistanceFromResidential(e.target.value)
  }

  const onDistanceLocation = (e) => {
    setDistanceLocation(e.target.value)
  }

  const onSamePersonName = (e) => {
    setSamePersonCurrName(e.target.value)
  }

  const onSamePersonOldName = (e) => {
    setSamePersonOldCurrName(e.target.value)

  }
  const onPostOffice = (e) => {
    setPostOffice(e.target.value)
  }


  const onBengPostOffice = (e) => {
    setBengPostOffice(e.target.value)
  }

  useEffect(() => {
    const jsonString = localStorage.getItem("Certificate_user");
    const data = JSON.parse(jsonString);
    setUserData(data);

  }, []);



  const onUniqueNo1 = (e) => {
    setUniqueNo1(e.target.value)
  }

  const onUniqueNo2 = (e) => {
    setUniqueNo2(e.target.value)
  }

  const onUniqueNo3 = (e) => {
    setUniqueNo3(e.target.value)
  }

  const onGsMember = (e) => {
    setGsMember(e.target.value)
  }

  const resDocId = (res) => {
    const data = res?.map((d, i) => {
      return { documentId: d?.DOCUMENT_ID, docUniqueNo: "", doc: "" }

    })
    setExpandedMenus(data)
  }
const matchedSansadNo = getSansadDataList.find(item => item.id == sansad)?.SansadNo || "";

// const matchedSansadNo = matchedItem ? matchedItem.SansadNo : "";

  console.log(block, gp, village, "susususumonomon")
  console.log(sansad,matchedSansadNo,"sansad")

  const onSubmit = () => {
    if (district == 0) {
      toast.error("Please Select District")
    } else if (block == 0) {
      toast.error("Please Select Block")
    } else if (gp == 0) {
      toast.error("Please Select GP")
    } else if (sansad == 0) {
      toast.error("Please Select Sansad")
    } else if (!gender) {
      toast.error("Please Select Applicant Salutation")
    } else if (!aplicantName) {
      toast.error("Please Type Applicant Name")
    } else if (!guardianName) {
      toast.error("Please Type Guardian Name")
    } else if (!relationWithGuardian) {
      toast.error("Please Select Realation with guardian")
    } else if (!address) {
      toast.error("Please Type your Address")
    } else if (!postOffice) {
      toast.error("Please Type Post Office")
    } else if (!policeStation) {
      toast.error("Please Type Police Station")
    } else if (village == 0) {
      toast.error("Please Select Village")
    } else if (pin.length !== 6) {
      toast.error("Please Type 6 digit Pin Code")
    } else if (!dob) {
      toast.error("Please Select DOB")
    } else if (
      selectedLanguage === "B" &&
      [bengAplicantName, bengGuardianName, bengRelationWithGuardian, bengAddress, bengPostOffice, bengPoliceStation, bengVillage, bengPin, bengDob].some((field) => !field)
    ) {
      toast.error("Please Type all Bengali Fields");
    } else if (
      selectedLanguage === "N" &&
      [bengAplicantName, bengGuardianName, bengRelationWithGuardian, bengAddress, bengPostOffice, bengPoliceStation, bengVillage, bengPin, bengDob].some((field) => !field)
    ) {
      toast.error("Please Type all Nepali Fields");
    } else if (incomeCertificate == "2" &&
      [incomeSource, annualIncome].some((field) => !field)
    ) {
      toast.error("Please Fill all Income Details")
    }
    else if (distanceCertificate == "5" &&
      [distanceFromResidential, distanceLocation].some((field) => !field)
    ) {
      toast.error("Please Fill all Distance Details")
    }
    else if (casteCertificate == "6" &&
      [religion, caste, subCaste].some((field) => !field)
    ) {
      toast.error("Please Fill all Caste Details")
    }
    else if (samePersonCertificate == "4" &&
      [samePersonCurrName, samePersonOldCurrName].some((field) => !field)
    ) {
      toast.error("Please Fill all Same Person Details")
    }
    else if (userData?.mobile.length != 10) {
      toast.error("Mobile Number length should be 10")
    } else if (!document1) {
      toast.error("Please Select Document 1")
    } else if (!uniqueNo1) {
      toast.error("Please Type Document Number")
    } else if (document1 === "Aadhaar Card" && uniqueNo1.length !== 12) {
      toast.error("Please Enter 12 Digit Aadhar Number")
    } else if (document1 === "PAN Card" && uniqueNo1.length !== 10) {
      toast.error("Please Enter 10 Digit PAN Number")
    } else if (document1 === "Voter ID Card" && (uniqueNo1?.length < 10 || uniqueNo1?.length > 20)) {
      toast.error("Voter ID must be between 10 and 20 characters long");
    } else if (document1 === "Driving License" && uniqueNo1.length !== 16) {
      toast.error("Please Enter 16 Digit Driving License")
    } else if (document1 === "Passport" && uniqueNo1.length !== 8) {
      toast.error("Please Enter 8 Digit Passport")
    } else if (!base64String) {
      toast.error("Please Upload Document 1")
    } else if (!document2) {
      toast.error("Please Select Document 2")
    } else if (!uniqueNo2) {
      toast.error("Please Type Document Number")
    } else if (document2 === "Aadhaar Card" && uniqueNo2?.length !== 12) {
      toast.error("Please Enter 12 Digit Aadhar Number")
    } else if (document2 === "PAN Card" && uniqueNo2?.length !== 10) {
      toast.error("Please Enter 10 Digit PAN Number")
    } else if (document2 === "Voter ID Card" && (uniqueNo2?.length < 10 || uniqueNo2?.length > 20)) {
      toast.error("Voter ID must be between 10 and 20 characters long");
    } else if (document2 === "Driving License" && uniqueNo2?.length !== 16) {
      toast.error("Please Enter 16 Digit Driving License")
    } else if (document2 === "Passport" && uniqueNo2?.length !== 8) {
      toast.error("Please Enter 8 Digit Passport")
    } else if (!base64String2) {
      toast.error("Please Upload Document 2")
    } else if (!previewImage) {
      toast.error("Please Upload Applicant Photo")
    } else {
      // setButtonActive(true);
      postCertificate(
        district, block, gp, matchedSansadNo, assesseeNo, assesseeName, aplicantName, relation,
        guardianName, relationWithGuardian, address, policeStation, postOffice, village,
        pin, dob, gender, certificate, userData?.mobile, getMobileNumber, getEmailInput, characterCertificate ? characterCertificate : 0,
        incomeCertificate ? incomeCertificate : 0, 3, samePersonCertificate ? samePersonCertificate : 0,
        distanceCertificate ? distanceCertificate : 0, incomeSource, annualIncome, distanceFromResidential, distanceLocation, samePersonOldCurrName, samePersonCurrName,
        document1, uniqueNo1, base64String, document2, uniqueNo2, base64String2, previewImage, bengAplicantName, bengGuardianName, bengRelationWithGuardian,
        bengAddress, bengPostOffice, bengPoliceStation, bengVillage, bengPin, bengDob, casteCertificate ? casteCertificate : 0, religion, caste, subCaste, uniqueNo3, base64String3, selectedLanguage,
        unmarriedCertificate,
        (res) => {
          if (res?.StatusCode == 0) {
            toast.success("Certificate Submitted Successfully")
            navigate(`/certificate-list`)
          } else if (res?.StatusCode == 1) {
            toast.error(res.StatusMsg)
          } else {
            console.log("nononononono")

          }
        }
      )
    }
  }

  useEffect(() => {
    getDistrictListData();
    getCertificateListData();

    getCertificateDocumentList(0, 0, 3, 0, 0, 0, 1).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList(response);

    });

    getCertificateDocumentList2(0, 0, 3, 0, 0, 0, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });
  }, []);

  //certificateListForCitizen



  async function getDistrictListData() {
    getDistrictList().then(function (result) {
      const response = result?.data;
      setDistrictDataList(response);
    });
  }

  let DistrictListDropDown = <option>Loading...</option>;
  if (getDistrictDataList && getDistrictDataList.length > 0) {
    DistrictListDropDown = getDistrictDataList.map((distRow, index) => (
      <option value={distRow.DIST_LGD}>{distRow.DIST_NAME}</option>
    ));
  }

  async function getCertificateListData() {
    getCertificateList().then(function (result) {
      const response = result?.data;
      setCertificateDataList(response);
    });
  }

  let CertificateListDropDown = <option>Loading...</option>;
  if (getCertificateDataList && getCertificateDataList.length > 0) {
    CertificateListDropDown = getCertificateDataList.map((certRow, index) => (
      <option value={certRow.CERT_ID}>{certRow.CERT_NAME}</option>
    ));
  }


  const onFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setBase64String(base64);
        setImagePreview(base64);
      };
      reader.readAsDataURL(file);
    }
  };


  // image proccessing
  // const onFile1 = (event) => {
  //   console.log(event.target.files[0], "filee")
  //   if (event["target"].files.length > 0) {
  //     const file = event["target"].files[0];
  //     setValueImage("image", {
  //       preview: URL.createObjectURL(event.target.files[0]),
  //       raw: event.target.files[0]
  //     });
  //     console.log(image, "asdsdsd")
  //     setGetImage(file)
  //     setGetImageresult(file.name)

  //   }

  // }


  const onFile1 = (event) => {
    const file = event.target.files[0];


    if (file.size > 2 * 1024 * 1024) {
      // 2 MB in bytes
      toast.error("File size should not exceed 2 MB.");
      setBase64String(null);
      setImagePreview(null)

    }
    else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setBase64String(base64);
        setImagePreview(base64);
      };
      reader.readAsDataURL(file);
    }
  };


  const onFile2 = (event) => {
    const file = event.target.files[0];

    if (file.size > 2 * 1024 * 1024) {
      // 2 MB in bytes
      toast.error("File size should not exceed 2 MB.");
      setBase64String2(null);
      setImagePreview2(null)
    }
    else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setBase64String2(base64);
        setImagePreview2(base64);
      };
      reader.readAsDataURL(file);
    }
  };


  const onFile3 = (event) => {
    const file = event.target.files[0];

    if (file.size > 2 * 1024 * 1024) {
      // 2 MB in bytes
      toast.error("File size should not exceed 2 MB.");
      setBase64String3(null);
      setImagePreview3(null)
    }
    else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setBase64String3(base64);
        setImagePreview3(base64);
      };
      reader.readAsDataURL(file);
    }
  };



  // image proccessing
  // const onFile2 = (event) => {
  //   console.log(event.target.files[0], "filee")
  //   if (event["target"].files.length > 0) {
  //     const file = event["target"].files[0];
  //     setValueImage("image", {
  //       preview: URL.createObjectURL(event.target.files[0]),
  //       raw: event.target.files[0]
  //     });
  //     console.log(image, "asdsdsd")
  //     setGetImage2(file)
  //     setGetImageresult2(file.name)

  //   }

  // }





  const onDistrict = (e) => {
    setDistrict(e.target.value)
    setBlock("")
    setGp("")
    setSansad("")
    setVillage("")
    getBlockList(e.target.value).then(function (result) {
      const response = result?.data;
      setBlockDataList(response);
    });
  }
  let BlockListDropDown = <option>Loading...</option>;
  if (getBlockDataList && getBlockDataList.length > 0) {
    BlockListDropDown = getBlockDataList.map((blRow, index) => (
      <option value={blRow.BLOCK_LGD}>{blRow.BLOCK_NAME}</option>
    ));
  }



  const onBlock = (e) => {
    setBlock(e.target.value)
    setGp("")
    setSansad("")
    setVillage("")
    getGpList(e.target.value).then(function (result) {
      const response = result?.data;
      setGpDataList(response);
    });
  }
  let GpListDropDown = <option>Loading...</option>;
  if (getGpDataList && getGpDataList.length > 0) {
    GpListDropDown = getGpDataList.map((gpRow, index) => (
      <option value={gpRow.GP_LGD}>{gpRow.GP_NAME}</option>
    ));
  }


  const onGp = (e) => {
    setGp(e.target.value)
    setSansad("")
    setVillage("")
    getSansadList(e.target.value).then(function (result) {
      const response = result?.data;

      // Add id: 1, 2, 3,...
      const updatedResponse = response.map((item, index) => ({
        ...item,
        id: index + 1
      }));

      setSansadDataList(updatedResponse);
    });

    console.log(getSansadDataList, "getSansadDataList")


    getVillageList(district, block, e.target.value,).then(function (result) {
      const response = result?.data;
      setVillageDataList(response);
    });
  }
  let SansadListDropDown = <option>Loading...</option>;
  if (getSansadDataList && getSansadDataList.length > 0) {
    SansadListDropDown = getSansadDataList.map((sanRow, index) => (
      <option value={sanRow.id}>{sanRow.Sansad}-{sanRow?.memberName}</option>
    ));
  }

  let VillageListDropDown = <option>Loading...</option>;
  if (getVillageDataList && getVillageDataList.length > 0) {
    VillageListDropDown = getVillageDataList.map((villRow, index) => (
      <option value={villRow.VILL_LGD}>{villRow.VILL_NAME}</option>
    ));
  }

  const onSansad = (e) => {
    console.log(e.target.value, "e.target.value")
    setSansad(e.target.value)
  }

  const onVillage = (e) => {
    setVillage(e.target.value)
  }

  const onBengVillage = (e) => {
    setBengVillage(e.target.value)
  }

  const onAssesseeNo = (e) => {
    setAssesseeNo(e.target.value)
  }

  const onAssesseeName = (e) => {
    setAssesseeName(e.target.value)
  }

  const handleKeyDown = (e) => {
    // Allow only letters (a-z, A-Z), space, and special control keys like Backspace
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
      "Enter",
    ];
    const isLetter = /^[a-zA-Z\s]$/.test(e.key);

    if (!isLetter && !allowedKeys.includes(e.key)) {
      e.preventDefault(); // Prevent invalid input
    }
  };


  const handleKeyDownNumber = (e) => {
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
      "Enter",
    ];
    const isNumber = /^[0-9]$/.test(e.key);

    if (!isNumber && !allowedKeys.includes(e.key)) {
      e.preventDefault(); // Prevent invalid input
    }
  };


  const onAplicantName = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setAplicantEngName(value);
    }

  }

  const onBengAplicantName = (e) => {
    setBengAplicantName(e.target.value)
  }


  const onRelation = (e) => {
    setRelation(e.target.value)
  }

  const onBengRelation = (e) => {
    setBengRelation(e.target.value)
  }

  const onGuardianName = (e) => {
    setGuardianName(e.target.value)
  }

  const onBengGuardianName = (e) => {
    setBengGuardianName(e.target.value)
  }

  const onRelationWithGuardian = (e) => {
    setRelationWithGuardian(e.target.value);
  }

  const onBengRelationWithGuardian = (e) => {
    setBengRelationWithGuardian(e.target.value);
  }

  const onAddress = (e) => {
    setAddress(e.target.value)
  }

  const onBengAddress = (e) => {
    setBengAddress(e.target.value)
  }

  const onPoliceStation = (e) => {
    setPoliceStation(e.target.value)
  }

  const onBengPoliceStation = (e) => {
    setBengPoliceStation(e.target.value)
  }

  const onPin = (e) => {
    setPin(e.target.value)
  }

  const onBengPin = (e) => {
    setBengPin(e.target.value)
  }

  const onDob = (e) => {
    setDob(e.target.value)
  }

  const onBengDob = (e) => {
    setBengDob(e.target.value)
  }

  const onReset = () => {
    window.location.reload()
  }

  const onCertificate = (e) => {
    setCertificate(e.target.value)


    getCertificateDocumentList2(e.target.value, 2).then(function (result) {
      const response = result?.data;
      setCertificateDocumentDataList2(response);

    });
    // resDocId(getCertificateDocumentDataList)

  }

  useEffect(() => {
    if (getCertificateDocumentDataList.length > 0) {
      resDocId(getCertificateDocumentDataList);
    }
  }, [getCertificateDocumentDataList])

  let CertificateDocumentDropDown = <option>Loading...</option>;
  if (getCertificateDocumentDataList && getCertificateDocumentDataList.length > 0) {
    CertificateDocumentDropDown = getCertificateDocumentDataList.map((blRow, index) => (
      <option value={blRow.DOCUMENT_NAME}>{blRow.DOCUMENT_NAME}</option>
    ));
  }

  let CertificateDocumentDropDown2 = <option>Loading...</option>;
  if (getCertificateDocumentDataList2 && getCertificateDocumentDataList2.length > 0) {
    CertificateDocumentDropDown2 = getCertificateDocumentDataList2.map((blRow, index) => (
      <option value={blRow.DOCUMENT_NAME}>{blRow.DOCUMENT_NAME}</option>
    ));
  }

  const onWhatsappNo = (e) => {
    const value = e.target.value;
    const regex = /^[6-9]{1}[0-9]{9}$/;
    if (regex.test(value) || value === '') {
      setWhatsappNumber(value);
      setIsValidWhatsapp(true);
    } else {
      setIsValidWhatsapp(false);
    }
  }

  const onEmail = (e) => {
    setEmailInput(e.target.value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmail(emailRegex.test(e.target.value));
  };


  const onDocument1 = (e) => {
    setDocument1(e.target.value)
  }

  const onDocument2 = (e) => {
    setDocument2(e.target.value)
  }

  const onGender = (e) => {
    if (e.target.value === "Mrs.") {
      setUnmarriedCertificate('')
      setGender(e.target.value)

    } else {
      setGender(e.target.value)
    }
  }

  const onCaste = (e) => {
    setCaste(e.target.value)
    getSubCasteCertificate(e.target.value).then(function (result) {
      const response = result?.data;
      setSubCasteDataList(response);
    });
  }

  let SubCasteListDropDown = <option>Loading...</option>;
  if (SubCasteDataList && SubCasteDataList.length > 0) {
    SubCasteListDropDown = SubCasteDataList.map((subRow, index) => (
      <option value={subRow.SubCastName}>{subRow.SubCastName}</option>
    ));
  }


  const onReligion = (e) => {
    setReligion(e.target.value)
  }

  const onSubCaste = (e) => {
    setSubCaste(e.target.value)
  }
  return (
    <div>
      <ToastContainer />
      <Navbar />
      <div class="grid-container cont sldr">
        <div class="grid-x grid-padding-x" style={{ marginBottom: "20px" }}>
          <div class="cell tran_div">
            <h2 style={{ marginLeft: "30px", marginButtom: "40px", color: "orange" }} class="text-center">Application form for Certificate</h2>
          </div>
          <div class="large-6 medium-12 small-12 cell">
            <div class="grid-x grid-padding-x">
              <div class="large-12 medium-12 small-12 cell">
                <fieldset class="fieldset_class" >
                  <legend style={{ color: "#026D7C", fontWeight: "bold" }}>GP Details</legend>
                  <div class="grid-x grid-padding-x">
                    <div class="large-6 medium-12 small-12 cell tran_div">
                      <div class="input-group">
                        <span class="input-group-label">District:<span class="impotnt">&nbsp;*</span></span>

                        <select ID="DISTRICT" onChange={onDistrict} value={district}>
                          <option value="0">--Select District--</option>
                          {DistrictListDropDown}
                        </select>

                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell tran_div">
                      <div class="input-group">
                        <span class="input-group-label">Block:<span class="impotnt">&nbsp;*</span></span>
                        <select ID="BLOCK" onChange={onBlock} value={block}>
                          <option value="0">--Select Block--</option>
                          {BlockListDropDown}
                        </select>
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell">
                      <div class="input-group">
                        <span class="input-group-label">Gram Panchayat:<span class="impotnt">&nbsp;*</span></span>
                        <select ID="GP" onChange={onGp} value={gp}>
                          <option value="0">--Select GP--</option>
                          {GpListDropDown}
                        </select>
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div1" >
                      <div class="input-group">
                        <span class="input-group-label">Sansad:<span class="impotnt">&nbsp;*</span></span>
                        <select ID="drp_sansad" onChange={onSansad} value={sansad}>
                          <option value="">--Select Sansad--</option>
                          {SansadListDropDown}
                        </select>
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div2" >
                      <div class="input-group">
                        <span class="input-group-label">Assessee No:
                          {/* <span class="impotnt">&nbsp;*</span> */}
                        </span>
                        <input type="text" ID="txt_assessee_no" placeholder="Assessee No" onkeypress="return isNumber(event)" class="input-group-field" onChange={onAssesseeNo} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div4" >
                      <div class="input-group">
                        <span class="input-group-label">Assessee Name:
                          {/* <span class="impotnt">&nbsp;*</span> */}
                        </span>
                        <input type="text" id="txt_assessee_name" placeholder="Assessee Name" class="input-group-field" onChange={onAssesseeName} onKeyDown={handleKeyDown} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div5" >
                      <div class="input-group">
                        <span class="input-group-label">Relation with Applicant:<span class="impotnt"></span></span>
                        <input type="text" id="txt_assessee_rel" placeholder="Relation with Applicant" class="input-group-field" onChange={onRelation} onKeyDown={handleKeyDown} />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              {/* newwwww */}

              <div class="large-12 medium-12 small-12 cell">
                <fieldset class="fieldset_class">
                  <legend style={{ color: "#026D7C", fontWeight: "bold" }}>Applicant Details</legend>

                  <div class="grid-x grid-padding-x">

                    <div class="large-6 medium-12 small-12 cell" id="Div13" >
                      <div >
                        <span className='impotnt'>( Applicant Details must be filled in English )</span>

                        {/* <span className='impotnt'>()</span> */}
                      </div>
                      <br></br>

                      <div class="input-group">
                        <span class="input-group-label">Salutation:<span class="impotnt">&nbsp;*</span></span>

                        <select ID="DISTRICT" onChange={onGender} value={gender}>
                          <option value="">--Select Salutation--</option>
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Miss">Miss</option>

                        </select>
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell tran_div " id="Div13" >
                      {/* <div class="large-6 medium-12 small-12 cell" id="Div13" > */}
                      <div >
                        <span className='impotnt'>( বাংলা শংসাপত্র পেতে দয়া করে বাংলায় লিখুন / नेपाली सर्टिफिकेट पाउन नेपाली लेख्नुहोस् )</span>
                        {/* <span className='impotnt'>()</span> */}
                      </div>
                      {/* </div> */}
                      <div class="input-group">
                        <span class="input-group-label"> Certificate required in:</span>&nbsp;&nbsp;

                        <input
                          type="checkbox"
                          class="form-check-input"
                          checked={selectedLanguage === "N"}
                          onChange={() => onCheckCerReq("N")}
                          disabled={selectedLanguage === "B"}
                        />
                        <label class="form-check-label" for="flexCheckDefault" style={{ marginTop: "3px" }}>
                          Nepali
                        </label>

                        <input
                          type="checkbox"
                          class="form-check-input"
                          checked={selectedLanguage === "B"}
                          onChange={() => onCheckCerReq("B")}
                          disabled={selectedLanguage === "N"}
                        />
                        <label class="form-check-label" for="flexCheckDefault" style={{ marginTop: "3px" }}>
                          Bengali
                        </label>
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span>

                        <input type="text" id="txt_applicant_name" placeholder="Applicant Name" class="input-group-field" onChange={onAplicantName}
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input type="text" id="txt_applicant_name" value={bengAplicantName} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "আবেদনকারীর নাম" : "आवेदकको नाम"} class="input-group-field" onKeyDown={handleKeyDown} onChange={onBengAplicantName} disabled={selectedLanguage == null} />
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div11" >
                      <div class="input-group">
                        <span class="input-group-label">Guardian Name:<span class="impotnt">&nbsp;*</span></span>
                        <input type="text" id="txt_guardian" placeholder="Guardian Name" class="input-group-field" onKeyDown={handleKeyDown} onChange={onGuardianName} />
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengGuardianName} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "আইনি অভিভাবক / অভিভাবকের নাম" : "कानुनी अभिभावक / अभिभावकको नाम"} class="input-group-field" onKeyDown={handleKeyDown} onChange={onBengGuardianName} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div12" >
                      <div class="input-group">
                        <span class="input-group-label">Relation with Guardian:<span class="impotnt">&nbsp;*</span></span>
                        <select onChange={onRelationWithGuardian} value={relationWithGuardian}>
                          <option value="">--Select Relation--</option>
                          <option value="Father">Father</option>
                          <option value="Mother">Mother</option>
                          <option value="Son">Son</option>
                          <option value="Daughter">Daughter</option>
                          <option value="Husband">Husband</option>
                          <option value="Spouse">Spouse</option>
                          <option value="Legal Guardian">Legal Guardian</option>
                        </select>
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengRelationWithGuardian} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "আইনি অভিভাবক / অভিভাবকের সাথে সম্পর্ক" : "कानुनी अभिभावक / अभिभावकसँगको सम्बन्ध"} class="input-group-field" onChange={onBengRelationWithGuardian} onKeyDown={handleKeyDown} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div6" >
                      <div class="input-group">
                        <span class="input-group-label">Address:<span class="impotnt">&nbsp;*</span></span>

                        <input type="text" id="txt_addr" placeholder="Address" class="input-group-field" onChange={onAddress} />

                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengAddress} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "ঠিকানা" : "ठेगाना"} class="input-group-field" onChange={onBengAddress} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div6" >
                      <div class="input-group">
                        <span class="input-group-label">Post Office:<span class="impotnt">&nbsp;*</span></span>

                        <input type="text" id="txt_addr" placeholder="Post Office" class="input-group-field" onChange={onPostOffice} />

                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengPostOffice} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "ডাকঘর" : "हुलाक कार्यालय"} class="input-group-field" onChange={onBengPostOffice} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div7" >
                      <div class="input-group">
                        <span class="input-group-label">Police Station:<span class="impotnt">&nbsp;*</span></span>

                        <input type="text" id="txt_habitation" placeholder="Police Station" class="input-group-field" onChange={onPoliceStation} />

                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengPoliceStation} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "থানা" : "प्रहरी चौकी"} class="input-group-field" onChange={onBengPoliceStation} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell">
                      <div class="input-group">
                        <span class="input-group-label">Village:<span class="impotnt">&nbsp;*</span></span>

                        <select onChange={onVillage} value={village}>
                          <option value="0">--Select Village--</option>
                          {VillageListDropDown}
                        </select>

                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengVillage} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "গ্রাম" : "गाउँ"} class="input-group-field" onChange={onBengVillage} />
                      </div>
                    </div>

                    <div class="large-6 medium-12 small-12 cell" id="Div8" >
                      <div class="input-group">
                        <span class="input-group-label">PIN:<span class="impotnt">&nbsp;*</span></span>

                        <input type="text" id="txt_pin" placeholder="Pin" onkeypress="return isNumber(event)" class="input-group-field" maxLength={6} onChange={onPin} onKeyDown={handleKeyDownNumber} />

                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengPin} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "পিন" : "पिन"} class="input-group-field" maxLength={6} onChange={onBengPin} onKeyDown={handleKeyDownNumber} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div13" >
                      <div class="input-group">
                        <span class="input-group-label">DOB:<span class="impotnt">&nbsp;*</span></span>

                        <input type="date" id="txt_dob" placeholder="DOB" textmode="Date" class="input-group-field" onChange={onDob} />
                      </div>
                    </div>
                    <div class="large-6 medium-12 small-12 cell" id="Div3" >
                      <div class="input-group">
                        {/* <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span> */}
                        <input value={bengDob} type="text" id="txt_applicant_name" disabled={selectedLanguage == null} placeholder={selectedLanguage == null ? "" : selectedLanguage == "B" ? "জন্ম তারিখ ইংরেজী বছর অনুযায়ী" : "जन्म मिति अंग्रेजी वर्ष अनुसार हो"} class="input-group-field" onChange={onBengDob} />
                      </div>
                    </div>



                  </div>
                </fieldset>
              </div>
            </div>
          </div>

          <div class="large-6 medium-12 small-12 cell">
            <fieldset class="fieldset_class">
              <legend style={{ color: "#026D7C", fontWeight: "bold" }}>Certificate Applied For</legend>
              <div class="grid-x grid-padding-x">
                <div class="large-12 medium-12 small-12 cell tran_div">
                  <span class="input-group-label" style={{ marginBottom: "10px" }}>Certificate Type:<span class="">&nbsp;*</span></span>
                  {/* {getCertificateDataList.slice(0, 3)?.map((option, index) => ( */}
                  <div class="input-group">
                    <input
                      class="form-check-input" type="checkbox" value="1" onChange={onCharacterCer}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Character Certificate
                    </label>
                    <input
                      class="form-check-input" type="checkbox" value="2" onChange={onIncomeCertificate}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Income Certificate
                    </label>

                    <input
                      class="form-check-input" type="checkbox" value="3" checked
                    />
                    <label>
                      Residential Certificate
                    </label>
                    <input
                      class="form-check-input" type="checkbox" value="5" onChange={onDistanceCertificate}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Distance Certificate
                    </label>

                  </div>
                </div>
                <div class="large-12 medium-12 small-12 cell tran_div">

                  <div class="input-group">

                    <input
                      class="form-check-input" type="checkbox" value="6" onChange={onCasteCertificate}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Caste Certificate
                    </label>

                    <input
                      class="form-check-input" type="checkbox" value="4" onChange={onSamePersonCertificate}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Same Person Certificate
                    </label>

                    <input
                      class="form-check-input" type="checkbox" value="7" onChange={onUnmarriedCertificate} disabled={gender === "Mrs." ? true : false}
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Unmarried Certificate
                    </label>
                  </div>
                </div>
                {incomeCertificate ?
                  <>
                    <div className='cell large-12' style={{ marginBottom: "10px" }}>
                      <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                        <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Income Certificate</legend>
                        <div className='grid-x grid-margin-x'>
                          <div class="large-6 medium-12 small-12 cell" id="Div9" >
                            <div class="input-group">
                              <span class="input-group-label">Annual Income of Family:<span class="impotnt">&nbsp;*</span></span>

                              <input type="text" id="txt_mobile" placeholder="Annual Income of Family" onkeypress="return isNumber(event)" class="input-group-field" onChange={onAnnualIncome} onKeyDown={handleKeyDownNumber} />

                            </div>

                          </div>
                          <div class="large-6 cell" id="Div9" >
                            <div class="input-group">
                              <span class="input-group-label">Source of Income:<span class="impotnt">&nbsp;*</span></span>

                              <input type="text" id="txt_mobile" placeholder="Source of Income" onkeypress="return isNumber(event)" class="input-group-field" onChange={onIncomeSource} onKeyDown={handleKeyDown} />

                            </div>

                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </>

                  : ""}
                {distanceCertificate ?
                  <>
                    <div className='cell large-12' style={{ marginBottom: "10px" }}>
                      <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                        <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Distance Certificate</legend>
                        <div className='grid-x grid-margin-x'>
                          <div class="large-6 medium-12 small-12 cell" id="Div9" >
                            <div class="input-group">
                              <span class="input-group-label">Distance From Residential (KM):<span class="impotnt">&nbsp;*</span></span>

                              <input type="text" id="txt_mobile" placeholder="Distance" onkeypress="return isNumber(event)" class="input-group-field" onChange={onDisFromRes} onKeyDown={handleKeyDownNumber} />

                            </div>

                          </div>

                          <div class="large-6 medium-12 small-12 cell" id="Div9" >
                            <div class="input-group">
                              <span class="input-group-label">Location:<span class="impotnt">&nbsp;*</span></span>

                              <input type="text" id="txt_mobile" placeholder="Location" onkeypress="return isNumber(event)" class="input-group-field" onChange={onDistanceLocation} onKeyDown={handleKeyDown} />

                            </div>

                          </div>

                        </div>

                      </fieldset>
                    </div>


                  </> : ""}


                {/* //for caste */}
                {casteCertificate ?
                  <div className='cell large-12' style={{ marginBottom: "10px" }}>
                    <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                      <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Caste Certificate</legend>
                      <div className='grid-x grid-margin-x'>
                        <div class="large-3 medium-6 small-6 cell tran_div">
                          <div class="input-group">
                            <span class="input-group-label">Religion:<span class="impotnt">&nbsp;*</span></span>
                            <select ID="BLOCK" onChange={onReligion}>
                              <option value="" selected>--Select Religion--</option>
                              <option value="Hinduism">Hinduism</option>
                              <option value="Islam">Islam</option>
                              <option value="Christianity">Christianity</option>
                              <option value="Sikhism">Sikhism</option>
                              <option value="Buddhism">Buddhism</option>
                              <option value="Animism/Adivasi">Animism/Adivasi</option>
                              <option value="Jainism">Jainism</option>
                              <option value="No religion">No religion</option>
                              <option value="Others">Others</option>



                            </select>
                          </div>
                        </div>
                        <div class="large-3 medium-6 small-6 cell tran_div">
                          <div class="input-group">
                            <span class="input-group-label">Caste:<span class="impotnt">&nbsp;*</span></span>
                            <select ID="BLOCK" onChange={onCaste}>
                              <option value="" selected>--Select Caste--</option>
                              <option value="1">General</option>
                              <option value="2">SC</option>
                              <option value="3">ST</option>
                              <option value="4">OBC-A</option>
                              <option value="5">OBC-B</option>

                            </select>
                          </div>
                        </div>


                        <div class="large-6 medium-12 small-12 cell tran_div">
                          <div class="input-group">
                            <span class="input-group-label">Sub Caste:<span class="impotnt">&nbsp;*</span></span>
                            <select ID="BLOCK" onChange={onSubCaste}>
                              <option value="">--Select Sub Caste--</option>
                              {SubCasteListDropDown}
                            </select>
                          </div>


                        </div>

                      </div>

                    </fieldset>
                  </div> : ""}


                {samePersonCertificate ?
                  <div className='cell large-12' style={{ marginBottom: "10px" }}>
                    <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                      <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Same Person Certificate</legend>
                      <div className='grid-x grid-margin-x'>
                        <div class="large-12 medium-12 small-12 cell" id="Div9" >
                          <div class="input-group">
                            <span class="input-group-label">Same Person Old name:<span class="impotnt">&nbsp;*</span></span>

                            <input type="text" id="txt_mobile" placeholder="Same Person Old name" onkeypress="return isNumber(event)" class="input-group-field" onChange={onSamePersonOldName} onKeyDown={handleKeyDown} />

                          </div>
                          <div class="input-group">
                            <span class="input-group-label">Same Person Current name:<span class="impotnt">&nbsp;*</span></span>

                            <input type="text" id="txt_mobile" placeholder="Same Person Current name" onkeypress="return isNumber(event)" class="input-group-field" onChange={onSamePersonName} onKeyDown={handleKeyDown} />

                          </div>

                        </div>
                      </div>

                    </fieldset>
                  </div>
                  : ""}
                <div class="large-6 medium-12 small-12 cell" id="Div9" >
                  <div class="input-group">
                    <span class="input-group-label">Mobile No:<span class="impotnt">&nbsp;*</span></span>

                    <input value={userData?.mobile} type="text" id="txt_mobile" placeholder="Mobile No" onkeypress="return isNumber(event)" class="input-group-field" disabled />

                  </div>

                </div>
                <div class="large-6 medium-12 small-12 cell" id="Div10" >
                  <div class="input-group">
                    <span class="input-group-label">Whatsapp No:</span>

                    <input maxLength={10} type="text" id="txt_whatsapp" placeholder="Whatsapp No" onkeypress="return isNumber(event)" class="input-group-field" onChange={onWhatsappNo} onKeyDown={handleKeyDownNumber} />

                  </div>
                  {!isValidWhatsapp && (
                    <div style={{ color: "red" }}>
                      Please enter a valid Mobile Number
                    </div>
                  )}
                </div>
                <div class="large-12 medium-12 small-12 cell" id="Div14" >
                  <div class="input-group">
                    <span class="input-group-label">Email:</span>

                    <input type="text" id="txt_email" placeholder="Email" class="input-group-field" onChange={onEmail} />

                  </div>
                </div>

                <div className='large-12 medium-12 small-12 cell'>
                  <div className='grid-x grid-margin-x'>
                    <div className='large-4 medium-4 small-12 cell'>
                      <span class="input-group-label">Select Document 1:<span class="impotnt">&nbsp;*</span></span>

                      <select onChange={onDocument1}>
                        <option value="0">--Select Document--</option>
                        {CertificateDocumentDropDown}
                      </select>
                    </div>
                    <div className='large-3 medium-3 small-12 cell'>
                      <span class="input-group-label">Document No 1<span class="impotnt">&nbsp;*</span></span>

                      <input type='text' placeholder='Document ID' name='docUniqueNo' onChange={onUniqueNo1} />
                    </div>
                    <div className='large-5 medium-5 small-12 cell'>
                      <span class="input-group-label">Upload Document <span class="impotnt">&nbsp;(PDF size max 2 MB)</span><span class="impotnt">&nbsp;*</span></span>

                      <input type="file" ID="doc_file" name='doc' onChange={onFile1} accept=".pdf, .jpeg, .jpg" />
                    </div>

                  </div>
                  <div className='grid-x grid-margin-x'>
                    <div className='large-4 medium-4 small-12 cell'>
                      <span class="input-group-label">Select Document 2:<span class="impotnt">&nbsp;*</span></span>

                      <select onChange={onDocument2}>
                        <option value="0">--Select Document--</option>
                        {CertificateDocumentDropDown2}
                      </select>
                    </div>
                    <div className='large-3 medium-3 small-12 cell'>
                      <span class="input-group-label">Document No 2<span class="impotnt">&nbsp;*</span></span>

                      <input type='text' placeholder='Document ID' name='docUniqueNo' onChange={onUniqueNo2} />
                    </div>

                    <div className='large-5 medium-5 small-12 cell'>
                      <span class="input-group-label">Upload Document<span class="impotnt">&nbsp;(PDF size max 2 MB)</span><span class="impotnt">&nbsp;*</span></span>

                      <input type="file" ID="doc_file" name='doc' onChange={onFile2} accept=".pdf, .jpeg, .jpg" />
                    </div>

                    <div className='large-4 medium-4 small-12 cell'>
                      <span class="input-group-label">GS Member Cert/Other DOC:</span>

                      <select onChange={onGsMember}>
                        <option value="0">--Select Document--</option>
                        <option value="0">GS Member Certificate</option>
                        <option value="0">Other Related Document</option>

                      </select>
                    </div>


                    <div className='large-3 medium-3 small-12 cell'>
                      <span class="input-group-label">Document No (If Any)</span>

                      <input type='text' placeholder='Document ID' name='docUniqueNo' onChange={onUniqueNo3} />
                    </div>

                    <div className='large-5 medium-5 small-12 cell'>
                      <span class="input-group-label">Upload Document<span class="impotnt">&nbsp;(PDF size max 2 MB)</span></span>

                      <input type="file" ID="doc_file" name='doc' onChange={onFile3} accept=".pdf" />
                    </div>

                    <div class="large-6 medium-6 small-12 cell" >
                      <div className='grid-x grid-margin-x'>

                        <div className='large-12 medium-8 small-12 cell'>
                          <label class="input-group-label">Upload Applicant Photo <span class="impotnt">&nbsp;(Size max 100KB)</span><span class="impotnt">&nbsp;*</span></label>


                        </div>

                        <div class="large-12 medium-8 small-12 cell" >
                          <div class="input-group">

                            <input
                              type="file"
                              accept=".jpeg, .jpg"
                              onChange={handleImageUpload}
                              ID="doc_file"
                            // style={{ margin: "10px 0" }}
                            />
                          </div>
                        </div>


                      </div>

                    </div>
                    <div className='large-6 medium-6 small-12 cell'>
                      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                      {previewImage && (

                        <div class="input-group align-right">
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{ width: "100px", height: "100px", borderRadius: "10px", marginBottom: "5px" }}
                          />
                        </div>

                      )}

                    </div>

                  </div>
                </div>

                <div className='grid-x grid-margin-x align-center'>
                  <div class="cell large-12 medium-12 small-12 ">

                    <input type="button" id="btn_save" class="btn" style={{ marginLeft: "250px" }} value="Submit" onClick={onSubmit} disabled={buttonActive} />
                    <input type="button" id="btn_reset" class="btn " style={{ marginLeft: "5px" }} value="Reset" onClick={onReset} />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

        </div>
      </div>

      <nav className="footer" style={{ marginTop: "120px" }}>
        <img src={footer} />
        <p className="text-center lastp" style={{ fontSize: "26px !important" }}><strong>©</strong>
          2024 Designed and Developed By <b>IT And Statistical Cell,</b> Panchayat & Rural
          Development Department <b>Govt. of West Bengal</b>
        </p>
        <p className="text-center lastp" style={{ fontSize: "26px !important" }}>Site best viewed with 1920x1080 resolution in
          Google Chrome 31.0.1650.63, Firefox 55.0.2, Safari 5.1.7 & IE 11.0 and above</p>
      </nav>
    </div>
  )
}

export default AddAchievement;